:host {
	display: block;
}
:host>smoothly-display {
	font-size: 2em;
}
:host>* {
	margin-bottom: 2rem;
}
:host smoothly-table-expandable-row {
	position: relative;
}
